import { Icon } from 'components';
import { Roles } from 'configs/roles';
// import { MainLayout } from 'layouts';
import MainLayout from 'layouts/Main';
import React, { lazy } from 'react';

import { MainRouteKeys } from '../enums';
import { MainRouteObject } from '../types';
import AuditLogsAdminPage from 'pages/audit-logs-admin';
import { Actions } from 'configs/actions';

const UsersPage = lazy(() => import('pages/Users'));
// const TransferPage = lazy(() => import('pages/transfers'));
const PersonalPage = lazy(() => import('pages/Personal'));
const PersonalInfoPage = lazy(() => import('pages/Personal/Info'));
const PersonalChangePasswordPage = lazy(
  () => import('pages/Personal/ChangePassword'),
);
const PersonalBalancePage = lazy(() => import('pages/Personal/Balance'));
const BalanceManagementPage = lazy(
  () => import('pages/Personal/Balance/Manage'),
);
const PersonalReward = lazy(() => import('pages/Personal/BalanceReward'));
const PersonalRewardPage = lazy(
  () => import('pages/Personal/BalanceReward/PersonalRewardManage'),
);
const BalanceTransferPage = lazy(
  () => import('pages/Personal/Balance/Transfer'),
);
const PersonalLogoutPage = lazy(() => import('pages/Personal/Logout'));
const PayBillPage = lazy(() => import('pages/PayBill'));
const PayBillElectricPage = lazy(() => import('pages/PayBill/Electric/List'));
const PayBillElectricDetailsPage = lazy(
  () => import('pages/PayBill/Electric/Details'),
);
const TransactionsPage = lazy(() => import('pages/Transactions'));
const TransactionOrdersPage = lazy(
  () => import('pages/Transactions/Orders/List'),
);
const TransactionOrderDetailsPage = lazy(
  () => import('pages/Transactions/Orders/Details'),
);
const TopUpPointsPage = lazy(() => import('pages/top-up-points'));
const UpdateUser = lazy(() => import('pages/update-user'));
const CustomersPage = lazy(() => import('pages/customers'));
const PointTransactionsPage = lazy(() => import('pages/point-transactions'));
const PointRewardTransactionsList = lazy(
  () => import('pages/point-reward-transactions'),
);
const OrdersPage = lazy(() => import('pages/orders'));
const TransactionIDBanksPage = lazy(() => import('pages/TransactionsBank'));
const AccountTPBankPage = lazy(() => import('pages/accountTPBank'));
const BankManagementPage = lazy(() => import('pages/Personal/BankManagement'));
const RequestWithdrawOwnPage = lazy(
  () => import('pages/request-withdraw/request-withdraw-own'),
);
const CreateRequestWithdrawPage = lazy(
  () => import('pages/request-withdraw/create-request-withdraw'),
);
const CheckRequestWithdrawPage = lazy(
  () => import('pages/request-withdraw/check-request-withdraw'),
);
const RequestWithdrawPage = lazy(() => import('pages/request-withdraw'));
const CompanyDepartmentPage = lazy(() => import('pages/company-department'));
const CompanyListPage = lazy(() => import('pages/company-department/company'));
const RefferalPage = lazy(() => import('pages/refferal'));
const RefferalDetailPage = lazy(() => import('pages/refferal/manage'));
const RefferalTransactionManagePage = lazy(
  () => import('pages/refferal/transaction'),
);
const WithdrawToMoraPay = lazy(
  () => import('pages/Personal/BalanceReward/WithdrawToMoraPay'),
);
const DepositFromMoraPay = lazy(
  () => import('pages/Personal/BalanceReward/DepositFromMoraPay'),
);

const EnergyDepartmentPage = lazy(() => import('pages/energy-department'));
const BranchEnergyPage = lazy(() => import('pages/energy-department/oil-type'));
const SupplierEnergyPage = lazy(
  () => import('pages/energy-department/supplier'),
);
const GasStationPage = lazy(() => import('pages/energy-department/oil-store'));
const TransactionsEnergyListPage = lazy(
  () => import('pages/energy-department/transactions'),
);
const BidvVirtualAccountPage = lazy(
  () => import('pages/bidv-virtual-account'),
);
const BidvVirtualAccountInquiryPage = lazy(
  () => import('pages/bidv-virtual-account/inquiry'),
);

export const MainRoutesConfig: MainRouteObject = {
  [MainRouteKeys.Root]: {
    path: MainRouteKeys.Root,
    name: 'Trang chủ',
    title: 'Trang chủ',
    element: <MainLayout />,
    redirectUrl: MainRouteKeys.Personal,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Personal]: {
    path: MainRouteKeys.Personal,
    name: 'Tài khoản',
    title: 'Tài khoản',
    element: <PersonalPage />,
    redirectUrl: MainRouteKeys.PersonalInfo,
    icon: <Icon.Profile />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalInfo]: {
    path: MainRouteKeys.PersonalInfo,
    name: 'Xem thông tin',
    title: 'Xem thông tin ',
    element: <PersonalInfoPage />,
    icon: <Icon.Data />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalChangePassword]: {
    path: MainRouteKeys.PersonalChangePassword,
    name: 'Thay đổi mật khẩu',
    title: 'Thay đổi mật khẩu ',
    element: <PersonalChangePasswordPage />,
    icon: <Icon.ChangePasswordIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalBalance]: {
    path: MainRouteKeys.PersonalBalance,
    name: 'Quản lý số dư',
    title: 'Quản lý số dư ',
    element: <PersonalBalancePage />,
    redirectUrl: MainRouteKeys.Balance,
    icon: <Icon.Wallet />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalReward]: {
    path: MainRouteKeys.PersonalReward,
    name: 'Điểm thưởng',
    title: 'Điểm thưởng',
    element: <PersonalReward />,
    redirectUrl: MainRouteKeys.PersonalRewardManage,
    icon: <Icon.Wallet />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalRewardManage]: {
    path: MainRouteKeys.PersonalRewardManage,
    name: 'Quản lý điểm thưởng',
    title: 'Quản lý điểm thưởng',
    element: <PersonalRewardPage />,
    icon: <Icon.Wallet />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.DepositFromMoraPay]: {
    path: MainRouteKeys.DepositFromMoraPay,
    name: 'Nạp điểm từ Mora Pay',
    title: 'Nạp điểm từ Mora Pay',
    element: <DepositFromMoraPay />,
    icon: <Icon.Exchange />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.WithdrawToMoraPay]: {
    path: MainRouteKeys.WithdrawToMoraPay,
    name: 'Rút điểm thưởng ra Mora Pay',
    title: 'Rút điểm thưởng ra Mora Pay',
    element: <WithdrawToMoraPay />,
    icon: <Icon.CoinExchange />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.BankManagement]: {
    path: MainRouteKeys.BankManagement,
    name: 'Quản lý Ngân hàng',
    title: 'Quản lý Ngân hàng',
    element: <BankManagementPage />,
    icon: <Icon.Collection />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PersonalLogout]: {
    path: MainRouteKeys.PersonalLogout,
    name: 'Đăng xuất',
    title: 'Đăng xuất ',
    element: <PersonalLogoutPage />,
    icon: <Icon.Logout />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.RequestWithdraw]: {
    path: MainRouteKeys.RequestWithdraw,
    name: 'Rút điểm',
    title: 'Yêu cầu rút điểm',
    element: <RequestWithdrawPage />,
    redirectUrl: MainRouteKeys.CreateRequestWithdraw,
    icon: <Icon.ClaimIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.CreateRequestWithdraw]: {
    path: MainRouteKeys.CreateRequestWithdraw,
    name: 'Tạo yêu cầu rút điểm',
    title: 'Tạo yêu cầu rút điểm',
    element: <CreateRequestWithdrawPage />,
    icon: <Icon.ClaimIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.RequestWithdrawOwn]: {
    path: MainRouteKeys.RequestWithdrawOwn,
    name: 'Quản lý Y/C rút điểm',
    title: 'Quản lý Y/C rút điểm',
    element: <RequestWithdrawOwnPage />,
    icon: <Icon.Collection />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.CheckRequestWithdrawList]: {
    path: MainRouteKeys.CheckRequestWithdrawList,
    name: 'Duyệt Y/C rút điểm',
    title: 'Duyệt Y/C rút điểm',
    element: <CheckRequestWithdrawPage />,
    icon: <Icon.ConfirmStatus />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: Actions.WithdrawPoint_ListRequest,
  },
  [MainRouteKeys.CompanyDepartment]: {
    path: MainRouteKeys.CompanyDepartment,
    name: 'Quản lý Hợp tác xã',
    title: 'Quản lý Hợp tác xã',
    element: <CompanyDepartmentPage />,
    redirectUrl: MainRouteKeys.Company,
    icon: <Icon.Product />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.ManageCompany_ListCompany,
  },
  [MainRouteKeys.Company]: {
    path: MainRouteKeys.Company,
    name: 'Quản lý hợp tác xã',
    title: 'Quản lý hợp tác xã',
    element: <CompanyListPage />,
    icon: <Icon.Product />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.ManageCompany_ListCompany,
  },
  [MainRouteKeys.Users]: {
    path: MainRouteKeys.Users,
    name: 'Quản lý người dùng',
    title: 'Quản lý người dùng',
    element: <UsersPage />,
    icon: <Icon.User />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.ManageUser_ListUser,
  },
  [MainRouteKeys.UpdateUser]: {
    path: MainRouteKeys.UpdateUser,
    name: 'Cập nhật người dùng',
    title: 'Cập nhật người dùng',
    element: <UpdateUser />,
    icon: <Icon.User />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: '',
  },
  [MainRouteKeys.Balance]: {
    path: MainRouteKeys.Balance,
    name: 'Quản lý số dư',
    title: 'Quản lý số dư',
    element: <PersonalBalancePage />,
    redirectUrl: MainRouteKeys.BalanceManage,
    icon: <Icon.Wallet />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.BalanceManage]: {
    path: MainRouteKeys.BalanceManage,
    name: 'Quản lý số dư',
    title: 'Quản lý số dư',
    element: <BalanceManagementPage />,
    icon: <Icon.CoinExchange />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Transfers]: {
    path: MainRouteKeys.Transfers,
    name: 'Chuyển điểm',
    title: 'Chuyển điểm',
    element: <BalanceTransferPage />,
    icon: <Icon.CoinExchange />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.TopUp]: {
    path: MainRouteKeys.TopUp,
    name: 'Nạp điểm',
    title: 'Nạp điểm',
    element: <TopUpPointsPage />,
    icon: <Icon.BalanceIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PayBill]: {
    path: MainRouteKeys.PayBill,
    name: 'Thanh toán hóa đơn',
    title: 'Thanh toán hóa đơn',
    element: <PayBillPage />,
    redirectUrl: MainRouteKeys.PayBillElectric,
    icon: <Icon.BalanceIcon />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PayBillElectric]: {
    path: `${MainRouteKeys.PayBillElectric}`,
    name: 'Hoá đơn điện',
    title: 'Hoá đơn điện',
    element: <PayBillElectricPage />,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PayBillElectricDetails]: {
    path: MainRouteKeys.PayBillElectricDetails,
    name: 'Thông tin đơn hàng',
    title: 'Thông tin đơn hàng',
    element: <PayBillElectricDetailsPage />,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Transactions]: {
    path: MainRouteKeys.Transactions,
    name: 'Quản lý giao dịch',
    title: 'Quản lý giao dịch',
    element: <TransactionsPage />,
    redirectUrl: MainRouteKeys.PointTransactions,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.TransactionBills]: {
    path: MainRouteKeys.TransactionBills,
    name: 'Thanh toán hóa đơn',
    title: 'Thanh toán hóa đơn',
    element: <TransactionOrdersPage />,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.TransactionBillDetails]: {
    path: MainRouteKeys.TransactionBillDetails,
    name: 'Thông tin đơn hàng',
    title: 'Thông tin đơn hàng',
    element: <TransactionOrderDetailsPage />,
    icon: <Icon.User />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Customers]: {
    path: MainRouteKeys.Customers,
    name: 'Quản lý khách hàng',
    title: 'Quản lý khách hàng',
    element: <CustomersPage />,
    icon: <Icon.Account />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: '',
  },
  [MainRouteKeys.PointTransactions]: {
    path: MainRouteKeys.PointTransactions,
    name: 'Cộng/trừ điểm',
    title: 'Cộng/trừ điểm',
    element: <PointTransactionsPage />,
    icon: <Icon.Account />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.PointRewardTransactions]: {
    path: MainRouteKeys.PointRewardTransactions,
    name: 'Điểm thưởng',
    title: 'Điểm thưởng',
    element: <PointRewardTransactionsList />,
    icon: <Icon.Collection />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.Orders]: {
    path: MainRouteKeys.Orders,
    name: 'Quản lý đơn hàng',
    title: 'Quản lý đơn hàng',
    element: <OrdersPage />,
    icon: <Icon.Account />,
    roles: '*',
    screenAction: '',
  },
  [MainRouteKeys.TPBank]: {
    path: MainRouteKeys.TPBank,
    name: 'Ngân hàng TPBank',
    title: 'Ngân hàng TPBank',
    element: <AccountTPBankPage />,
    redirectUrl: MainRouteKeys.AccountBank,
    icon: <Icon.Wallet />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: [
      Actions.TPBank_InqueryTransaction,
      Actions.TPBank_ResendTransaction,
    ],
  },
  [MainRouteKeys.AccountBank]: {
    path: MainRouteKeys.AccountBank,
    name: 'Truy vấn tiểu khoản',
    title: 'Truy vấn tiểu khoản',
    element: <AccountTPBankPage />,
    icon: <Icon.User />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.TPBank_InqueryTransaction,
  },
  [MainRouteKeys.TransactionsBank]: {
    path: MainRouteKeys.TransactionsBank,
    name: 'Gửi lại giao dịch',
    title: 'Gửi lại giao dịch',
    element: <TransactionIDBanksPage />,
    icon: <Icon.Exchange />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.TPBank_ResendTransaction,
  },
  [MainRouteKeys.Refferal]: {
    path: MainRouteKeys.Refferal,
    name: 'Sự kiện Giới thiệu',
    title: 'Sự kiện Giới thiệu',
    element: <RefferalPage />,
    redirectUrl: MainRouteKeys.RefferalDetail,
    icon: <Icon.GameIcon />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: [
      Actions.ManageReferralEvent_ViewEvent,
      Actions.ManageReferralEvent_ListTransaction,
    ],
  },
  [MainRouteKeys.RefferalDetail]: {
    path: MainRouteKeys.RefferalDetail,
    name: 'Chi tiết sự kiện',
    title: 'Chi tiết sự kiện',
    element: <RefferalDetailPage />,
    icon: <Icon.GameIcon />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.ManageReferralEvent_ViewEvent,
  },
  [MainRouteKeys.RefferalDetailHistory]: {
    path: MainRouteKeys.RefferalDetailHistory,
    name: 'Lịch sử giao dịch',
    title: 'Lịch sử giao dịch',
    element: <RefferalTransactionManagePage />,
    icon: <Icon.Transfer />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.SPVISOR],
    screenAction: Actions.ManageReferralEvent_ListTransaction,
  },
  [MainRouteKeys.AuditLogsAdmin]: {
    path: MainRouteKeys.AuditLogsAdmin,
    name: 'Logs Admin',
    title: 'Logs Admin',
    element: <AuditLogsAdminPage />,
    icon: <Icon.Collection />,
    roles: [Roles.SUPER_ADMIN],
    screenAction: '',
  },
  // Energy Department Routes
  [MainRouteKeys.EnergyDepartment]: {
    path: MainRouteKeys.EnergyDepartment,
    name: 'Q.Lý Merchant',
    title: 'Q.Lý Merchant',
    element: <EnergyDepartmentPage />,
    redirectUrl: MainRouteKeys.TransactionEnergy,
    icon: <Icon.ClaimIcon />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.OIL_MC],
    screenAction: [
      Actions.ManageOilMerchant_ListOilStoreType,
      Actions.ManageOilMerchant_ListOilSupplier,
      Actions.ManageOilMerchant_ListOilStore,
      Actions.ManageOilMerchant_GetOilStoreTransaction,
    ],
  },
  [MainRouteKeys.BranchEnergy]: {
    path: MainRouteKeys.BranchEnergy,
    name: 'Thương hiệu',
    title: 'Thương hiệu',
    element: <BranchEnergyPage />,
    icon: <Icon.Affiliate />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.OIL_MC],
    screenAction: Actions.ManageOilMerchant_ListOilStoreType,
  },
  [MainRouteKeys.SupplierEnergy]: {
    path: MainRouteKeys.SupplierEnergy,
    name: 'Nhà cung cấp',
    title: 'Nhà cung cấp',
    element: <SupplierEnergyPage />,
    icon: <Icon.Category />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.OIL_MC],
    screenAction: Actions.ManageOilMerchant_ListOilSupplier,
  },
  [MainRouteKeys.GasStation]: {
    path: MainRouteKeys.GasStation,
    name: 'Điểm kinh doanh',
    title: 'Điểm kinh doanh',
    element: <GasStationPage />,
    icon: <Icon.Info />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.OIL_MC],
    screenAction: Actions.ManageOilMerchant_ListOilStore,
  },
  [MainRouteKeys.TransactionEnergy]: {
    path: MainRouteKeys.TransactionEnergy,
    name: 'Giao dịch',
    title: 'Giao dịch',
    element: <TransactionsEnergyListPage />,
    icon: <Icon.User />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.OIL_MC],
    screenAction: Actions.ManageOilMerchant_GetOilStoreTransaction,
  },
  [MainRouteKeys.BidvVirtualAccount]: {
    path: MainRouteKeys.BidvVirtualAccount,
    name: 'Tài khoản ảo BIDV',
    title: 'Quản lý tài khoản ảo BIDV',
    element: <BidvVirtualAccountPage />,
    icon: <Icon.Wallet />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    redirectUrl: MainRouteKeys.BidvVirtualAccountInquiry,
    screenAction: [Actions.ManageBIDVVAS_ListVA, Actions.ManageBIDVVAS_InqueryTransaction, Actions.ManageBIDVVAS_SyncTransaction],
  },
  // [MainRouteKeys.BidvVirtualAccountList]: {
  //   path: MainRouteKeys.BidvVirtualAccountList,
  //   name: 'Tài khoản ảo BIDV',
  //   title: 'Quản lý tài khoản ảo BIDV',
  //   element: <BidvVirtualAccountPage />,
  //   icon: <Icon.User />,
  //   roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
  //   screenAction: Actions.ManageBIDVVAS_ListVA,
  // },
  [MainRouteKeys.BidvVirtualAccountInquiry]: {
    path: MainRouteKeys.BidvVirtualAccountInquiry,
    name: 'Tra cứu tài khoản ảo BIDV',
    title: 'Tra cứu tài khoản ảo BIDV',
    element: <BidvVirtualAccountInquiryPage />,
    icon: <Icon.Search />,
    roles: [Roles.SUPER_ADMIN, Roles.ADMIN],
    screenAction: Actions.ManageBIDVVAS_InqueryTransaction,
  },
};
